import { Context } from '@nuxt/types';
import Vue from 'vue';

/**
 * @description
 * This filter is used to prepend the CDN URL to the given value.
 * It checks if the value starts with a slash and concatenates it with the CDN host accordingly.
 * If the value is empty or null, it returns an empty string.
 * @usage
 * {{ 'path/to/resource.jpg' | cdn }} => 'https://cdn.example.com/path/to/resource.jpg'
 * {{ '/path/to/resource.jpg' | cdn }} => 'https://cdn.example.com/path/to/resource.jpg'
 * {{ '' | cdn }} => ''
 * {{ null | cdn }} => ''
 * @param {string} value - The path to the resource that needs to be prefixed with the CDN URL.
 * @returns {string} - The full URL to the resource on the CDN.
 */
export default function (context: Context) {
  Vue.filter('cdn', function (value) {
    const host = context.$config.CDN_URL;
    if (value) {
      if (/^\//i.test(value)) {
        return `${host}${value}`;
      }
      return `${host}/${value}`;
    }
    return '';
  });
}
